import { getRequestConfig } from './index';

export const doGetFeed = (params: string[], signal: AbortSignal) => {
  const headers = getRequestConfig();
  return fetch(`/json/app/newsfeed?${params.join('&')}`, Object.assign({}, headers, { signal: signal}));
};
